import { z } from 'zod'
import noLeadingSpaces from '../../../../../utilities/noLeadingSpaces'

export const formSchema = z.object({
  applicant_type: z
    .string({ invalid_type_error: 'Required.' })
    .min(1, { message: 'Required.' }),
  role: z.any(),

  organization_name: z
    .string()
    .min(1, { message: 'Organization name is required.' })
    .max(25, { message: 'Maximum 25 characters allowed.' })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),

  address: z
    .string()
    .min(1, { message: 'Address is required.' })
    .max(100, { message: 'Maximum 100 characters allowed.' }),

  city: z.string().min(1, { message: 'City is required.' }),

  state_province: z.string().min(1, { message: 'State/Province is required.' }),

  zip_postal_code: z
    .string()
    .min(1, { message: 'ZIP/Postal Code is required.' }),

  country: z.string().min(1, { message: 'Country is required.' }),

  website: z.string().min(1, { message: 'Website is required.' }),
  year_of_establishment: z.coerce
    .number({
      required_error: 'Year is required',
      invalid_type_error: 'Year must be a number',
    })
    .int()
    .refine((val) => /^\d{4}$/.test(String(val)), {
      message: 'Year must be a 4-digit number.',
    })
    .transform((val) => Number(val))
    .refine((val) => val >= 1900 && val <= new Date().getFullYear(), {
      message: 'Enter a valid year.',
    }),

  organization_description: z
    .string()
    .min(1, { message: 'Description is required.' }),

  contact_name: z.string().min(1, { message: 'Contact name is required.' }),

  contact_title: z.string().min(1, { message: 'Contact title is required.' }),

  contact_email: z
    .string()
    .min(1, { message: 'Contact email is required.' })
    .refine((val) => /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(val), {
      message: 'Invalid email format.',
    })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),

  contact_phone: z.coerce
    .string()
    .optional()
    .transform((val) => val?.trim() || '')
    .refine(
      (val) => val === '' || /^\+91\d{10}$/.test(val) || /^\d{10}$/.test(val),
      {
        message: 'Enter a valid 10-digit mobile number (with or without +91)',
      }
    ),
})

export type AdminSchema = z.infer<typeof formSchema>
